import { render, staticRenderFns } from "./IngredientCost.vue?vue&type=template&id=6f897e8f&scoped=true"
import script from "./IngredientCost.vue?vue&type=script&lang=ts"
export * from "./IngredientCost.vue?vue&type=script&lang=ts"
import style0 from "./IngredientCost.vue?vue&type=style&index=0&id=6f897e8f&prod&scoped=true&lang=css"
import style1 from "./IngredientCost.vue?vue&type=style&index=1&id=6f897e8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f897e8f",
  null
  
)

export default component.exports